import { createContext } from 'react';
import { useContext } from 'react';
const defaultValue = {
  currentUserCanCommunicate: false
};
export const CreateActivityPermissionsContext = /*#__PURE__*/createContext(defaultValue);
export const useCreateActivityPermissions = () => {
  const permissions = useContext(CreateActivityPermissionsContext);
  if (permissions === undefined) {
    throw new Error('CreateActivityPermissionsContext has not been set');
  }
  return permissions;
};